
<template>
  <div>
    <div class="policy_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <p class="mobitxt">ČESKÝ TEXT</p>
          <p class="mobitxt">Všeobecné podmínky</p>
          <p class="mobitxt">Naposledy změněno: 13/08/2021</p>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">1. Použitelnost</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              Níže uvedené podmínky (Všeobecné podmínky) platí pro anglickou
              verzi jednorázové placené služby Funplus Premium (Puretech Global
              Sdn Bhd a / nebo Služba) nabízené online prostřednictvím internetu
              od společnosti Puretech Global Sdn Bhd (dále jen jako Puretech
              Global Sdn Bhd). Koncový uživatel požaduje službu Funplus od
              společnosti Puretech Global Sdn Bhd.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">2. Obecné</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              Funplus poskytuje nejlepší sexy tapety a videa výhradně pro váš
              mobil.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">3. Potvrzení / registrace</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              Aby koncový uživatel získal přístup k Funplus, musí zadat číslo
              svého mobilního telefonu a / nebo určitá další data a / nebo
              informace prostřednictvím propagační webové stránky (Landing Page)
              provozované společností Puretech Global Sdn Bhd. Poté koncový
              uživatel obdrží na své mobilní zařízení SMS , s osobním
              identifikačním číslem (PIN kód) nebo takzvanou nabídkovou zprávou
              s informacemi o službě. Koncový uživatel zadáním přijatého PIN
              kódu na úvodní stránce a / nebo odesláním potvrzovací zprávy a /
              nebo používáním služby potvrzuje a potvrzuje, že si přečetl
              Všeobecné podmínky, je autorizovaným majitelem účtu mobilního
              telefonu nebo má souhlas plátce telefonního účtu s využitím této
              služby. Koncový uživatel obdrží potvrzovací SMS zprávu o úspěšné
              aktivaci služby Funplus, způsobu, frekvenci a nákladech na stažení
              Služby a také přesné údaje o odhlášení.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">4. Náklady a poplatky</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              Funplus je placená služba, která stojí 1 SMS x 99,00 CZK / týden
              Poplatek bude účtován na účet za mobilní telefon nebo na
              předplacené mobilní číslo. Způsob nabíjení je Premium MT SMS
              zasílaná koncovému uživateli na základě jeho požadavku na službu
              Funplus. Tato zpráva bude obsahovat vaše přihlášení do Funplus.
              Poplatky se vybírají podle provozovatelů mobilních sítí. Poplatky
              jsou odepsány na účet Koncového uživatele Provozovatelem; v
              případě SIM s předplatným jsou poplatky odečteny z kreditu
              Koncového uživatele. Koncový uživatel mu tímto výslovně uděluje
              právo účtovat poplatky a zavazuje se zaplatit v plné výši poplatky
              vzniklé v důsledku předplatného a / nebo používání služby Funplus.
              Pokud nejste osobou odpovědnou za placení účtu za mobilní telefon,
              před přihlášením a / nebo používáním Funplusu si vyžádejte
              povolení od svého mobilního plátce. Podpisem a / nebo účastí ve
              službě Puretech Global Sdn Bhd předpokládá, že koncový uživatel
              získal potřebné povolení, souhlas nebo schválení od plátce
              mobilního účtu, opatrovníka nebo rodičů. Všechny SMS zprávy
              zasílané koncovým uživatelem budou mobilním operátorem koncového
              uživatele účtovány za standardní tarif. Tyto sazby se mohou u
              jednotlivých operátorů lišit. Další informace o poplatcích vám
              poskytne váš GSM operátor.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">5. Pomoc a podpora</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              Zákaznický servis je k dispozici v pracovní dny od 09:00 do 17:00
              Kontakt: +421 313215999 nebo funplus.cz@silverlines.info
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">6. Duševní vlastnictví</h2>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
          <div class="mobiFaq">
            <p class="mobitxt">
              Službu můžete používat pro osobní, nekomerční použití. Pojem
              Funplus a všechny ostatní ochranné známky, servisní značky a /
              nebo obchodní názvy používané Funplusem ve Službě čas od času
              (ochranné známky) jsou ochranné známky, servisní značky a / nebo
              obchodní názvy společnosti Puretech Global Sdn Bhd nebo jedné z
              jejích společností v skupina nebo její poskytovatelé licencí a
              tyto subjekty si vyhrazují veškerá práva k ochranným známkám.
              Kromě toho další obsah Služeb, mimo jiné včetně her, obrázků,
              obrázků, grafik, fotografií, animací, videí, hudby, zvuku a textu,
              patří společnosti Funplus nebo jedné z jejích společností a / nebo
              licencovaných skupin a jsou chráněny autorským právem a / nebo
              jinými právy duševního vlastnictví. Berete na vědomí, že
              používáním Služby nezískáte žádná práva na ochrannou známku ani
              Obsah Služby, než jak je uvedeno v této Smlouvě. Za žádných
              okolností nesmíte za žádných okolností kopírovat jakýkoli obsah
              služby (včetně, bez omezení, vědomostních otázek, odpovědí nebo
              her), ani ve službě používat dolování dat, roboty, škrábance na
              obrazovce nebo podobné nástroje pro sběr a extrakci dat.
              Odpovědnost Použití Funplus a / nebo webové stránky Funplus je na
              vlastní riziko koncového uživatele. Koncový uživatel musí
              poskytnout kompatibilní mobilní telefon, hardware nebo jiná
              zařízení a software a zajistit, aby byly funkční a vhodné pro
              služby Funplus. Funplus nemůže zaručit, že služby Funplus budou
              splňovat požadavky koncových uživatelů a že stahování, přijímání a
              / nebo prohlížení služeb Funplus bude nepřerušované nebo bez chyb.
              Pokud koncový uživatel kdykoli nemůže bez přerušení používat
              službu Puretech Global Sdn Bhd, v žádném případě to nezakládá
              právo na snížení poplatků za služby Funplus, na jakékoli právo na
              vrácení předplacených plateb. Jakékoli použití služeb Funplus je
              na uvážení a riziku koncového uživatele, a to za, nikoli však
              výhradně, infekci nebo kontaminaci nebo ztrátu dat nebo poškození
              hardwaru a / nebo softwaru koncového uživatele z přístupu na Web,
              z používání Služeb Funplus nebo stažených Služeb Funplus, včetně
              hardwaru a softwaru potřebného k připojení ke Službám Funplus. Je
              odpovědností koncových uživatelů, aby přijali nezbytná opatření,
              která zabrání možnému poškození tohoto druhu. V případě, že je
              Funplus z jakéhokoli důvodu povinen nahradit koncovému uživateli
              přímé nebo následné škody jakéhokoli druhu, nesmí taková náhrada v
              žádném případě překročit hodnotu faktury za služby Funplus
              zaplacené koncovým uživatelem za údajné škody . Obsah webových
              stránek byl sestaven s největší péčí. Společnost Funplus však
              nemůže poskytnout žádnou záruku, pokud jde o povahu, přesnost nebo
              obsah těchto informací. Funplus neodpovídá za žádné chyby,
              opomenutí, nepřesnosti, nedorozumění, zpoždění nebo nečitelné
              objednávky nebo oznámení založená na používání internetu nebo
              příslušného informačního bodu. Závěrečná ustanovení Veškeré spory
              týkající se plnění těchto Obchodních podmínek budou řešit
              příslušné obecné soudy. Puretech Global Sdn Bhd si vyhrazuje právo
              čas od času tyto podmínky změnit. Změny budou koncovým uživatelům
              oznámeny zveřejněním na portálu Funplus.
            </p>
          </div>
          <div class="mobiFaq">
            <p></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["countryCode"]),
};
</script>
<style>
.mobiFaq ul {
  list-style: inherit !important;
  padding-left: 30px !important;
}
.mobitxt a {
  display: inline !important;
  color: black !important;
}
.mobitxt a:hover {
  color: #007bff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/funplus/TermsCzech.vue